import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate,  useLocation } from 'react-router-dom';

import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import { StButton } from '../0_microelements/A4_StButton';
import { CalendarMonth, WorkspacePremium, EmojiEvents, Group } from '@mui/icons-material';


const Events = ({ multiple }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [events, setEvents] = useState([]); // Store all events of the selected type
  const [selectedType, setSelectedType] = useState('SSW'); // Track selected event type

 useEffect(() => {
  console.log("Fetching events for type:", selectedType);
  const fetchEvents = async () => {
    setEvents([]);
    try {
       //const response = await fetch(`${process.env.REACT_APP_API_URL}/api/type/events?type=${selectedType}`);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/events/type?type=${selectedType}`);

      if (!response.ok) throw new Error("Failed to fetch events");
      const eventsData = await response.json();
      //!multiple ? setEvents([eventsData[0]]) : setEvents(eventsData);
      setEvents(eventsData);
    } catch (error) {
      console.error("Error fetching events:", error);
      setEvents([]);
    }
  };

  fetchEvents();
}, [selectedType, multiple]);



const eventTypes = [
  {
    id: 'SSW',
    title: 'Super Sunday Workshop',
    description: 'Weekly hands-on coding workshops for students and educators',
    icon: <CalendarMonth fontSize="large" sx={{ color: "#fff" }} />,
    bg: 'linear-gradient(135deg, #f3e5f5, #f8bbd0)'
  },
  {
    id: 'CSG',
    title: 'CS Gems',
    description: 'Discover hidden gems in computer science with expert-led sessions',
    icon: <WorkspacePremium fontSize="large" sx={{ color: "#fff" }} />,
    bg: 'linear-gradient(135deg, #c8e6c9, #a5d6a7)'
  },
  {
    id: 'SSL',
    title: 'Super School Leadership',
    description: 'Empowering school leaders with vision and strategy for 21st-century education',
    icon: <Group fontSize="large" sx={{ color: "#fff" }} />,
    bg: 'linear-gradient(135deg, #d1c4e9, #b39ddb)'
  },
  {
    id: 'NCOJ',
    title: 'National Coding Olympiad Junior',
    description: 'Nationwide coding competition for young programmers',
    icon: <EmojiEvents fontSize="large" sx={{ color: "#fff" }} />,
    bg: 'linear-gradient(135deg, #fff9c4, #ffe082)'
  },
  {
    id: 'CSAW',
    title: "C-SAW Computer Science Teachers' Conclave",
    description: 'Annual gathering of computer science educators',
    icon: <Group fontSize="large" sx={{ color: "#fff" }} />,
    bg: 'linear-gradient(135deg, #b3e5fc, #81d4fa)'
  }
];

  const eventStyles = (type) => ({
    width: { lg: '210px', sm: '90%', xs: '230px' },
    margin: 0.5,
    height: { lg: '200px', sm: '150px', xs: '150px' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 2,
    borderRadius: 2,
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'gray', // fixed text color
    backgroundColor: '#f5f5f5', // fixed background color (light gray)
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'scale(1.08)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',
    },
  });

  // const parseHTML = (htmlString) => {
  //   const parser = new DOMParser();
  //   return parser.parseFromString(htmlString, "text/html").body.textContent;
  // };

  const eventColors = {
    SSW: '#f3e5f5',
    CSG: '#c8e6c9',
    NCOJ: '#fff9c4',
    CSAW: '#e0f7fa'
  };

  let hrstyle = {
    borderLeft: { lg: "5px solid #eb7e91" },
    borderTop: { xs: "5px solid #eb7e91" },
    height: { lg: "190px", xs: '0' },
    width: { xs: '190px', lg: '0px' },
    margin: { lg: "0 15px", xs: "15px 0" },
    borderRadius: '10px',
  }

  return (
    <Box sx={{ mt: { xs: '120px', md: '140px' } }}>

      <Box sx={{ fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white' }}>
        <Box sx={{ width: '80%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: 3 }}>
          {/* <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>EVENTS SERIES</Typography> */}
          <Typography variant="h4" fontWeight="bold" mb={2}>Events Series</Typography>
      <Typography variant="subtitle1" mb={5}>
        Join our exciting events designed to inspire learning, foster innovation, and build community connections
      </Typography>
      {/* for new event cards */}

      {/* <Box
  sx={{
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    justifyContent: 'center',
    width: '100%',
    mt: 3,
    mb: { xs: 10, sm: 10, lg: 4 }
  }}
>
  {eventTypes.map((event) => (
    <Box
      key={event.id}
      onClick={() => setSelectedType(event.id)}
      sx={{
        width: 260,
        minHeight: 260,
        borderRadius: 4,
        background: event.bg,
        padding: 3,
        boxShadow: '0px 10px 25px rgba(0,0,0,0.08)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
        '&:hover': {
          transform: 'translateY(-5px)'
        }
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          backgroundColor: '#00000033',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 2
        }}
      >
        {event.icon}
      </Box>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {event.title}
      </Typography>
      <Typography variant="body2">{event.description}</Typography>
    </Box>
  ))}
</Box> */}


           <Box sx={{ margin: 3, marginBottom: { sm: 13, xs: 13, lg: 3, md: 3 }, display: 'flex', width: '90%', height: '200px', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'column', lg: 'row', md: 'row' }, alignItems: 'center' }}>
            <Box sx={{ ...eventStyles('SSW'), backgroundColor: '#f3e5f5' }} onClick={() => setSelectedType('SSW')}>Super Sunday<br /> Workshop</Box>
            <Box sx={{ ...eventStyles('CSG'), backgroundColor: '#c8e6c9' }} onClick={() => setSelectedType('CSG')}>CS Gems</Box>
            <Box sx={{ ...eventStyles('SSL'), backgroundColor: '#d1c4e9' }} onClick={() => setSelectedType('SSL')}>
              Super School <br /> Leadership
            </Box>
            <Box sx={{ ...eventStyles('NCOJ'), backgroundColor: '#fff9c4' }} onClick={() => setSelectedType('NCOJ')}>National Coding <br /> Olympiad Junior</Box>
            <Box sx={{ ...eventStyles('CSAW'), backgroundColor: '#e0f7fa' }} onClick={() => setSelectedType('CSAW')}>C-SAW - Computer <br /> Science Teachers' <br /> Conclave</Box>
          </Box> 

          {events.length > 0 && (
            <Box sx={{ width: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              {events.map((event, index) => (

                event && (
  <Box
    key={index}
    sx={{
      width: '100%',
      backgroundColor: eventColors[selectedType] || '#e6f4ec',
      margin: 5,
      padding: 3,
      borderRadius: 2,
      display: 'flex',
      flexDirection: { xs: 'column', lg: 'row' },
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      boxShadow: '0px 4px 12px rgba(0,0,0,0.05)'
    }}
  >
    {/* Left Image */}
    <Box
      sx={{
        width: { lg: '25%', xs: '100%' },
        mb: { xs: 2, lg: 0 }
      }}
    >
      {event.imageURL && (
        <img
          src={process.env.REACT_APP_API_URL + event.imageURL}
          alt="Event"
          style={{
            width: '100%',
            height: '180px',
            objectFit: 'cover',
            borderRadius: '10px'
          }}
        />
      )}
    </Box>

    {/* Description */}
    <Box
      sx={{
        width: { lg: '45%', xs: '100%' },
        px: 2,
        textAlign: { xs: 'center', lg: 'left' },
        fontSize: '16px',
        color: '#333'
      }}
    >
      <Box dangerouslySetInnerHTML={{ __html: event.description }} />
    </Box>

    {/* Date, Time, Venue, Buttons */}
    <Box
      sx={{
        width: { lg: '30%', xs: '100%' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: { xs: 'center', lg: 'flex-start' },
        mt: { xs: 3, lg: 0 },
        px: 2
      }}
    >
      <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: 600, mb: 1 }}>
         <strong>Date:</strong> {event.date}
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: 600, mb: 1 }}>
         <strong>Time:</strong> {event.time}
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '16px', fontWeight: 600, mb: 2 }}>
         <strong>Venue:</strong> {event.venue}
      </Typography>

      {/* Know More Button */}
      {/* Buttons */}
<Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
  {/* Know More Button */}
  <Button
    onClick={() => navigate(`/event-details/${selectedType}`, { state: { event } })}
    sx={{
      backgroundColor: '#fecc00', // Updated Yellow
      color: '#fff',
      fontWeight: 600,
      padding: '10px 24px',
      borderRadius: '50px',
      fontSize: '14px',
      width: '160px',
      alignSelf: { xs: 'center', lg: 'flex-start' },
      textTransform: 'uppercase',
      letterSpacing: '1px',
      boxShadow: '0 4px 12px rgba(161, 159, 97, 1)',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#fecc00',
        transform: 'scale(1.05)',
        boxShadow: '0 6px 18px rgba(198, 193, 40, 0.4)'
      }
    }}
  >
    Know More
  </Button>

  {/* Register Button */}
  {event?.joinLink && (
    <a
      href={event.joinLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <Button
        sx={{
          backgroundColor: '#28a745',
          color: '#fff',
          fontWeight: 600,
          padding: '10px 24px',
          borderRadius: '50px',
          fontSize: '14px',
          width: '160px',
          alignSelf: { xs: 'center', lg: 'flex-start' },
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: '0 4px 12px rgba(40, 167, 69, 0.3)',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: '#218838',
            transform: 'scale(1.05)',
            boxShadow: '0 6px 18px rgba(40, 167, 69, 0.4)'
          }
        }}
      >
        Register
      </Button>
    </a>
  )}
</Box>
    </Box>
  </Box>
)

              ))}
            </Box>

          )}

          {/* Archieve Section */}

          {location.pathname.startsWith('/events') && (
            <>
              <Box sx={{ width: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: 4 }} />

              <Box sx={{ width: '100%', mt: 10, textAlign: 'center' }}>
                <Divider>
                  <Chip label="Archive Section" />
                </Divider>

                <Box sx={{ my: 5 }}>
                  <StButton hit="/archive" text="Go To Archive" />
                </Box>
              </Box>
            </>
          )}

        </Box>

      </Box>
    </Box>
  );
};


export default Events;
